export enum InvestmentOperationType {
  TYPE_FREE_INVESTMENT = 'free-investment',
  TYPE_PARTIAL_SELL = 'partial-sell',
  TYPE_TOTAL_SELL = 'total-sell',
  TYPE_ARBITRAGE = 'arbitrage',
  TYPE_START_INVESTMENT = 'start-monthly-investment',
  TYPE_UPDATE_INVESTMENT = 'update-monthly-investment',
  TYPE_STOP_INVESTMENT = 'stop-monthly-investment'
}
